/**
 * WooCommerce notices (add to cart, removed from cart, payment cancelled …)
 * shown as toasts below the header icons. Styles: woocommerce/global/_notice-wrapper.scss
 */
const toastNotices = ( ( document, window ) => {
	const SUCCESS_TIMEOUT = 6000;
	const SELECTOR =
		'.woocommerce-notices-wrapper > .woocommerce-message, .woocommerce-notices-wrapper > .woocommerce-error, .woocommerce-notices-wrapper > .woocommerce-info';

	const _position = () => {
		const root = document.documentElement;
		const header = document.querySelector( '.site-header' );
		const wrap = document.querySelector( '.site-header .wrap' );

		if ( header ) {
			const bottom = Math.max( header.getBoundingClientRect().bottom, 0 );
			root.style.setProperty( '--lc-toast-top', `${ Math.round( bottom ) }px` );
		}
		if ( wrap ) {
			const right = window.innerWidth - wrap.getBoundingClientRect().right;
			root.style.setProperty(
				'--lc-toast-right',
				`${ Math.max( Math.round( right ), 16 ) }px`
			);
		}
	};

	const _dismiss = ( notice ) => {
		notice.classList.add( 'is-leaving' );
		window.setTimeout( () => notice.remove(), 250 );
	};

	const _enhance = ( notice ) => {
		if ( notice.dataset.toast ) {
			return;
		}
		// WooCommerce's cart script moves every notice of the refreshed cart
		// into the wrapper, the "cart is empty" text included. That one is the
		// page content, not a toast.
		if ( notice.classList.contains( 'cart-empty' ) ) {
			const holder = document.querySelector( '.wc-empty-cart-message' );
			if ( holder && ! holder.contains( notice ) ) {
				holder.appendChild( notice );
			}
			return;
		}
		notice.dataset.toast = '1';

		const { closeTxt } = window.l18n_js_theme || {};
		const close = document.createElement( 'button' );
		close.type = 'button';
		close.className = 'lc-toast-close';
		close.setAttribute( 'aria-label', closeTxt || 'Close' );
		close.addEventListener( 'click', () => _dismiss( notice ) );
		notice.appendChild( close );

		const isError =
			notice.classList.contains( 'woocommerce-error' ) ||
			notice.querySelector( '.lc-notice-removed' );
		if ( ! isError ) {
			window.setTimeout( () => _dismiss( notice ), SUCCESS_TIMEOUT );
		}
	};

	const _scan = () => {
		document.querySelectorAll( SELECTOR ).forEach( _enhance );
	};

	const init = () => {
		_position();
		_scan();

		window.addEventListener( 'resize', _position );
		window.addEventListener( 'scroll', _position, { passive: true } );

		// Cart and checkout re-render their notices via AJAX.
		const observer = new MutationObserver( _scan );
		document
			.querySelectorAll( '.woocommerce-notices-wrapper' )
			.forEach( ( wrapper ) =>
				observer.observe( wrapper, { childList: true } )
			);
		if ( window.jQuery ) {
			window.jQuery( document.body ).on( 'updated_wc_div', _scan );
		}
	};

	return {
		init,
	};
} )( document, window );

export default toastNotices;
